<script setup>
import {computed} from 'vue';
import SlickCarousel from '../SlickCarousel.vue';

const {item} = defineProps({
    item: Object,
    userId: String,
});

const isFavorited = computed(() => item.isFavorited);
const isDisabled = computed(() => item.activateUrl || item.seller.onHoliday);
</script>

<template>
    <div :class="{'is-disabled': isDisabled}" class="is-relative">
        <a :href="item.detailUrl" class="product-link"></a>
        <figure class="item-item">
            <span v-if="item.isCertified" class="certified-logo">
                <span class="is-hidden-until-large">Les paires de nos clients</span>
                <img class="is-hidden-from-large" src="/images/icon/check-circle-certified.svg" alt="">
            </span>
            <span v-else-if="item.isManufactured" class="manufactured-logo">
                <span class="is-hidden-until-large">Seconde chance</span>
                <span class="is-hidden-from-large">{{ item.info.brand === 'Mellow Yellow' ? '-60%' : '-50%' }}</span>
            </span>
            <span v-else-if="item.isMarket" class="market-logo">
                Seconde main
            </span>
            <SlickCarousel class="image-wrapper" :options="{}">
                <a :href="item.detailUrl" v-for="image in item.images">
                    <img :src="image" :alt="item.name" class="product-image">
                </a>
            </SlickCarousel>
            <figcaption class="item-infos">
                <div class="item-name-wrapper">
                    <h3 class="item-name">{{ item.info.brand }}</h3>
                </div>
                <div class="is-flex brand is-hidden-until-large">
                    <span class="item-brand">{{ item.name }}</span>
                </div>
                <div class="is-flex price">
                    <span v-if="item.isManufactured  && !item.isGebetex" class="promo-price is-hidden-until-large">
                        {{ item.info.brand === 'Mellow Yellow' ? '-60%' : '-50%' }}
                    </span>
                    <span class="item-price">{{ item.price }}</span>
                    <span class="item-base-price" v-if="item.type === 'manufactured' && !item.isGebetex">
                        {{ item.basePrice }}
                    </span>
                </div>
                <div>
                    <span class="item-cut" v-if="item.info.cut.length === 1"> {{ item.info.cut[0] }}</span>
                    <span class="item-cut" v-else> {{ item.info.cut.length }} pointures</span>
                    <span class="icon-heart js-favorite-item"
                          :item="item.id"
                          :class="{'icon-heart-fill': isFavorited}"
                          v-show="item.seller.id !== userId">
                        {{ item.countFavorited }}
                    </span>
                </div>
            </figcaption>
        </figure>
    </div>
</template>
